import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import moment from "moment";
import TableContainer from '../../Components/Common/TableContainer';
import { listUser } from '../../pages/User/_requests';
const RecentCustomers = () => {
  const [recentUserList, setUserList] = useState<any>([]);
  useEffect(() => {
    const data = { limit: 10 };
    listUser(data).then((res: any) => {
      setUserList(res);
    });

  }, []);
  console.log("recentUserList Recent Customer", recentUserList)
  // Column
  const columns = useMemo(
    () => [
      {
        header: "S.No",
        id: "sno",
        enableColumnFilter: false,
        cell: (cellProps: any) => {
          return cellProps.row.index + 1;
        },
      },
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0 me-3">
                <div className="avatar-sm bg-light rounded p-1">
                  <img
                    className="img-fluid d-block"
                    src={
                      cell.row.original.profile
                        ? cell.row.original.profile
                        : require("../../assets/images/users/user-dummy-img.jpg")
                    }
                    alt={cell.row.original.profile ? "user-profile" : "default-profile"}
                    style={{
                      height: "100%",
                      width: "auto",
                      maxHeight: "40px",
                      maxWidth: "40px",
                      objectFit: "cover",
                      borderRadius: "50%",
                      display: "block",
                    }}
                  />{" "}
                </div>
              </div>
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1 ">
                  <Link
                    to={`/user/view/${cell.row.original.id}`}
                    className="custom-redirect-link"
                  // className="text-body"
                  >
                    {" "}
                    {cell.getValue()}
                  </Link>
                </h5>
              </div>
            </div>
          </>
        ),
      },

      {
        header: "Phone No",
        accessorKey: "mobile_number",
        enableColumnFilter: false,
      },
      {
        header: "Email",
        accessorKey: "email",
        enableColumnFilter: false,
      },

    ],
    []
  );




  return (
    <React.Fragment>
      <Card>
        <CardHeader className="card-header border-0">
          <Row className="align-items-center gy-3">
            <div className="col-sm">
              <h5 className="card-title mb-0">Recent Customers</h5>
            </div>
          </Row>
        </CardHeader>
        <CardBody>
          <div>
            {recentUserList?.length ? (
              <TableContainer
                columns={columns}
                data={recentUserList || []}
                customPageSize={10}
                divClass="table-responsive table-card mb-1 mt-0"
                tableClass="align-top table-bordered align-top table-nowrap"
                theadClass="table-light fw-bold"
              />
            ) : (
              <p className="fw-bold text-center">No Results Found</p>
            )}
          </div>
        </CardBody>
      </Card>

    </React.Fragment>
  );
};

export default RecentCustomers;